import { Env } from '../services/environment';

// disable pesky google maps writing to console in prod build
export const configureConsole = (env: Env): void => {
  if (env !== Env.DEV) {
    const methods = ['log', 'debug', 'warn', 'info'];
    methods.forEach((_m, idx) => ((console as any)[methods[idx]] = () => {}));
  }
};
